module.exports = __webpack_public_path__ + "static/media/ENVIRONMENT.c34baf74.svg";